export const COUNTRIES = [
  'Australia',
  'Canada',
  'India',
  'Mexico',
  'Nepal',
  'Sri Lanka',
  'Switzerland',
  'UK',
  'US',
  'Vietnam',
];
export const NEPAL = 'Nepal';

export const COUNTRIES_FORM_LIST = ['All', ...COUNTRIES];
